<mat-icon [fontSet]="fontSet()" [class]="class()">
  <teller [teller]="teller()" [skjulTellerDersomNull]="skjulTellerDersomNull()"/>
</mat-icon>
